<template>
    <div class="flex flex-col gap-3">
        <BaseCard v-for="i in count" :key="i" padding="md">
            <div class="flex items-center gap-4">
                <!-- Title placeholder -->
                <SkeletonLoader role="none" aria-hidden="true" class="h-4 flex-1 rounded" :style="{ maxWidth: `${titleWidths[i - 1]}%` }" />
                <!-- Badge placeholder -->
                <SkeletonLoader role="none" aria-hidden="true" class="h-5 w-20 shrink-0 rounded-full" />
                <!-- Icon placeholders -->
                <SkeletonLoader role="none" aria-hidden="true" class="h-5 w-4 shrink-0 rounded" />
                <SkeletonLoader role="none" aria-hidden="true" class="h-5 w-4 shrink-0 rounded" />
            </div>
        </BaseCard>
    </div>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
const { count = 3 } = defineProps<{ count?: number }>();

const titleWidths = [55, 70, 45, 60, 50];
</script>
